import { useUser } from "@/lib/Auth/useUser";
import { useResendVerification } from "@/lib/Auth/useResendVerification";
import { EnvelopeIcon } from "@heroicons/react/20/solid";

export function EmailVerificationBanner() {
  const user = useUser();
  const { mutate: resend, isPending } = useResendVerification();

  if (!user || user.email_verified) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-x-3 bg-amber-500 px-6 py-2 sm:px-3.5">
      <EnvelopeIcon className="h-4 w-4 text-white" />
      <p className="text-sm font-medium text-white">
        Please verify your email address. Check your inbox for a verification
        link.
      </p>
      <button
        type="button"
        onClick={() => resend()}
        disabled={isPending}
        className="rounded-full bg-white/20 px-3 py-0.5 text-sm font-semibold text-white hover:bg-white/30 disabled:opacity-60"
      >
        {isPending ? "Sending..." : "Resend"}
      </button>
    </div>
  );
}
